const messages = {
  poNumber: 'PO#',
}

export default messages
